import type { GrowthPoint } from './growth-model';
import type { ChartMetric } from './line-chart';

export type GrowthDetailRow = {
  label: string;
  value: number | null;
  currency?: 'USD';
};

export const growthDetailRows = (
  point: GrowthPoint,
  metric: ChartMetric,
  metricLabel: string,
  visible: {
    signups: boolean;
    paid: boolean;
    appUsers: boolean;
    revenue: boolean;
  },
  goalLabel = 'Signups',
): GrowthDetailRow[] => [
  { label: metricLabel, value: point[metric] },
  ...(visible.signups && point.signups !== null
    ? [{ label: goalLabel, value: point.signups }]
    : []),
  ...(visible.appUsers && point.newAppUsers !== null
    ? [{ label: 'New app users', value: point.newAppUsers }]
    : []),
  ...(visible.paid && point.newPaid !== null
    ? [{ label: 'New paid', value: point.newPaid }]
    : []),
  ...(visible.revenue && point.recordedRevenueUsd !== null
    ? [
        {
          label: 'Payments (USD)',
          value: point.recordedRevenueUsd,
          currency: 'USD' as const,
        },
      ]
    : []),
];

/** Keep the tooltip beside its point, flipping only when the right side runs out of room. */
export const growthTooltipPosition = (
  anchor: { x: number; y: number },
  plot: { width: number; height: number },
  tooltipHeight: number,
) => {
  const inset = 8;
  const gap = 16;
  const width = Math.min(208, Math.max(0, plot.width - inset * 2));
  const preferredLeft =
    anchor.x + gap + width <= plot.width - inset
      ? anchor.x + gap
      : anchor.x - gap - width;
  return {
    width,
    left: Math.max(inset, Math.min(plot.width - width - inset, preferredLeft)),
    top: Math.max(
      inset,
      Math.min(
        plot.height - tooltipHeight - inset,
        anchor.y - tooltipHeight / 2,
      ),
    ),
  };
};
